exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rowHeight {\n  height: 145px;\n  overflow: auto; }\n\n.row {\n  margin-left: 8px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/edit-costumer/edit-costumer.component.scss
// module id = ../../../../../src/app/edit-costumer/edit-costumer.component.scss
// module chunks = main